<div class="options">
    <div ngbDropdown class="dropdown dropdown-inline">
        <a ngbDropdownToggle class="btn-arquivo btn btn-clean btn-sm btn-icon" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="hgi hgi-stroke hgi-more-horizontal text-dark"></i>
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-md dropdown-menu-right">
            <ul class="navi navi-hover">
                <li class="navi-item">
                    <a class="navi-link cursor-pointer">
                        <span class="navi-text">
                            <span>Renomear</span>
                        </span>
                    </a>
                </li>
                <li class="navi-item">
                    <a class="navi-link cursor-pointer">
                        <span class="navi-text">
                            <span>Excluir </span>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
